import { axios } from "../../../../constants/axiosConfig";
// import { getResults } from "../../Result/actions";
import { message, notification } from "antd";

// Retornar lista de configurações de empresa
export function getListConfiguration() {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return async (dispatch) => {
    dispatch({ type: "GET_LIST_CONFIGURATION_REQUEST" });
    await axios
      .get(`configurar/${cnpj}`)
      .then((response) => {
        dispatch({
          type: "GET_LIST_CONFIGURATION_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "GET_LIST_CONFIGURATION_FAILURE" }));
  };
}

// Retornar item de configurações de empresa
export function getItemConfiguration(id) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return async (dispatch) => {
    dispatch({ type: "GET_ITEM_CONFIGURATION_REQUEST" });
    await axios
      .get(`configurar/${cnpj}/${id}`)
      .then((response) => {
        dispatch({
          type: "GET_ITEM_CONFIGURATION_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => dispatch({ type: "GET_ITEM_CONFIGURATION_FAILURE" }));
  };
}

// Editar configuração específica
export function putConfiguration(data) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  return async (dispatch) => {
    dispatch({ type: "PUT_CONFIGURATION_REQUEST" });
    await axios
      .put(`configurar/${cnpj}`, JSON.stringify(data))
      .then((response) => {
        dispatch({
          type: "PUT_CONFIGURATION_SUCCESS",
          payload: response.data,
        });

        if (response.data?.StatusCode === 200) {
          this.getResults();

          notification["success"]({
            message: "Configuração alterada com sucesso",
            description:
              "Essa alteração começará a ser válida a partir da próxima importação.",
            duration: 8,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "PUT_CONFIGURATION_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          message.error(error.response.data.Mensagem);
        }
      });
    dispatch({ type: "CLEAN_CONFIGURATION" });
  };
}

export function putConfigurationList(data) {
  return async (dispatch) => {
    dispatch({ type: "PUT_CONFIGURATION_REQUEST" });
    await axios
      .put(`configurar`, JSON.stringify(data))
      .then((response) => {
        dispatch({
          type: "PUT_CONFIGURATION_SUCCESS",
          payload: response.data,
        });

        if (response.data?.StatusCode === 200) {
          notification["success"]({
            message: "Configuração alterada com sucesso",
            description:
              "Essa alteração começará a ser válida a partir da próxima importação.",
            duration: 8,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "PUT_CONFIGURATION_FAILURE" });
        if (error && error.response && error.response.status !== 403) {
          message.error(error.response.data.Mensagem);
        }
      });
    dispatch({ type: "CLEAN_CONFIGURATION" });
  };
}

export function changeConfiguration(id, idImportacao, value) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return axios
      .get(`configurar/${cnpj}/${id}`)
      .then(async (response) => {
        var data = {
          ...response.data.Retorno,
          Status: value
        };

        return await axios
        .put(`configurar/${cnpj}${idImportacao ? "?idImportacao=" + idImportacao : ""}`, JSON.stringify(data))
        .then((response) => {
          if (response.data?.StatusCode === 200) {
            notification["success"]({
              message: "Configuração alterada com sucesso",
              description:
                "Essa alteração começará a ser válida a partir da próxima importação.",
              duration: 8,
            });
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.status !== 403) {
            message.error(error.response.data.Mensagem);
          }
        });
      });
}